import api from './api';

export type ModalType = 'achievement' | 'skillstree_completion' | 'passport';

export interface CheckModalResponse {
  has_shown: boolean;
}

export interface MarkShownResponse {
  id: number;
  modal_type: ModalType;
  entity_id: number;
}

export interface BatchCheckModal {
  modal_type: ModalType;
  entity_id: number;
}

export interface BatchCheckResponse {
  results: Array<{
    modal_type: ModalType;
    entity_id: number;
    has_shown: boolean;
  }>;
}

interface ApiResponseWrapper<T> {
  status: string;
  message: string;
  data: T;
}

export const modalApi = {
  /**
   * Check if a modal has been shown for a user
   */
  checkModal: async (
    modalType: ModalType,
    entityId: number
  ): Promise<CheckModalResponse> => {
    const response = await api.get<ApiResponseWrapper<CheckModalResponse>>('/v1/modals/check', {
      params: {
        modal_type: modalType,
        entity_id: entityId,
      },
    });
    return response.data.data;
  },

  /**
   * Mark a modal as shown for a user
   */
  markModalAsShown: async (
    modalType: ModalType,
    entityId: number
  ): Promise<MarkShownResponse> => {
    const response = await api.post<ApiResponseWrapper<MarkShownResponse>>('/v1/modals/mark-shown', {
      modal_type: modalType,
      entity_id: entityId,
    });
    return response.data.data;
  },

  /**
   * Batch check multiple modals at once
   */
  batchCheckModals: async (
    modals: BatchCheckModal[]
  ): Promise<BatchCheckResponse> => {
    const response = await api.post<ApiResponseWrapper<BatchCheckResponse>>('/v1/modals/batch-check', {
      modals,
    });
    return response.data.data;
  },
};

